import { render, staticRenderFns } from "./SettingsHeader.vue?vue&type=template&id=2dd8d3b7&scoped=true&"
import script from "./SettingsHeader.vue?vue&type=script&lang=js&"
export * from "./SettingsHeader.vue?vue&type=script&lang=js&"
import style0 from "./SettingsHeader.vue?vue&type=style&index=0&id=2dd8d3b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd8d3b7",
  null
  
)

export default component.exports